import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SingleDraftsState } from '../reducers/single-drafts.reducer';
import { SINGLE_DRAFTS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<SingleDraftsState>(SINGLE_DRAFTS_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: SingleDraftsState) => state.loaded);
export const selectDraftsList = createSelector(selectState, (state: SingleDraftsState) => state.draftsList);
